/*
 * @Descripttion:盲盒商城商品
 * @Author: lc
 * @Date: 2021-10-25 08:33:06
 * @LastEditors: lc
 * @LastEditTime: 2023-05-08 10:11:44
 */
import axios from '../.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const goods = {
    // 列表
    list (params) {
        return axios.get(api + 'mangheshopgoods/list', { params: params })
    },
    //添加
    create (params) {
        return axios.post(api + 'mangheshopgoods/create', qs.stringify(params))
    },
    //添加原规格
    createorispec (params) {
        return axios.post(api + 'mangheshopgoods/createorispec', qs.stringify(params))
    },
    //获取编辑信息
    detail (params) {
        return axios.get(api + 'mangheshopgoods/detail', { params: params })
    },
    //修改
    edit (params) {
        return axios.post(api + 'mangheshopgoods/edit', qs.stringify(params))
    },
    //删除
    remove (params) {
        return axios.post(api + 'mangheshopgoods/remove', qs.stringify(params))
    },
    //状态
    status (params) {
        return axios.post(api + 'mangheshopgoods/status', qs.stringify(params))
    },
    import (params) {
        return axios.post(api + 'mangheshopgoods/import', qs.stringify(params))
    },
}


// 导出接口
export default goods


